import { PencilSimpleLine } from '@phosphor-icons/react'
import Spinner from 'components/Spinner'
import { Table } from 'antd'
import { useGetAmenities } from 'api/Listings/Amenties'
import moment from 'moment'
import React, { useEffect, useMemo } from 'react'
import { amenitiesCreationStore } from 'state/listing/amenitiesListing'
import { AmenityListing } from 'api/Listings/Amenties'

interface AmenitiesTableProps {
  id: string
}

const AmenitiesTable: React.FC<AmenitiesTableProps> = ({ id }) => {
  const { data, isLoading, isFetching, refetch } = useGetAmenities()
  const { setAddAmenitiesModal, setAmenitiesData } = amenitiesCreationStore(
    store => ({
      setAddAmenitiesModal: store.setAddAmenitiesModal,
      setAmenitiesData: store.setAmenitiesData,
    }),
  )

  const handleEditClick = (data: AmenityListing) => {
    setAmenitiesData(data)
    setAddAmenitiesModal(true)
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text: string) => <p className="text-14 w-400">{text}</p>,
    },
    {
      title: 'Icon',
      dataIndex: 'icon',
      key: 'icon',
      render: (text: string) => (
        <img src={text} alt="icon" className="w-30px h-30px radius-rounded" />
      ),
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (text: string) => (
        <p className="text-14 w-400">{moment(text).format('DD MMM, YYYY')}</p>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      width: '100px',
      render: (data: AmenityListing) => (
        <div className="flex align-center gap-20px">
          <PencilSimpleLine
            size={20}
            color="#000"
            className="pointer"
            onClick={() => handleEditClick(data)}
          />
        </div>
      ),
    },
  ]

  useEffect(() => {
    refetch()
  }, [id, refetch])

  const tableData = useMemo(() => {
    return (
      data?.map((item: any) => ({
        key: item._id,
        name: item.name,
        icon: item.icon.thumb,
        updatedAt: item.updatedAt,
        actions: item,
      })) || []
    )
  }, [data])

  return (
    <div>
      {isLoading || isFetching ? (
        <div className="w-full h-70vh flex align-center justify-center">
          <Spinner />
        </div>
      ) : (
        <Table
          className="colored_header_table"
          columns={columns}
          dataSource={tableData}
          pagination={false}
        />
      )}
    </div>
  )
}

export default AmenitiesTable
